import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"
import ScrollReveal from 'scrollreveal';

class App {
    constructor() {
        this.Utils = new Utils();
        this.Accordion = new Accordion();
        this.Anchor = new Anchor();
        this.FixedHeader = new FixedHeader();
        this.HeightLine = new HeightLine();
        this.ResponsiveTable = new ResponsiveTable();
        this.Slidebar = new Slidebar();
        this.CurrentNav = new CurrentNav();
        this.Tab = new Tab();

        //SPメニューの高さ取得
        function menuHight() {
            var win = $(window).innerWidth();
            if (win > 750) {
                return false;
            }

            var $smpHeaderHeight = $('.l-header').height();
            var windowHeight = window.innerHeight;
            var winH = windowHeight - $smpHeaderHeight;

            console.log($smpHeaderHeight);

            //動かすターゲットを取得
            var targetSlidebarWrap = $('.c-slidebar-menu'),
                targetSlidebarMenu = $('.c-slidebar__parent'),
                targetSlidebarBtn = $('.c-slidebar-menu__parent');


            //いざ実行(クリックしたら処理を実行する)
            targetSlidebarBtn.on('click', function () {
                $('.c-slidebar-menu').toggleClass('is-active');

            });
        }


        //top-specialのホバー画像切り替え
        function hoverImage() {
            $('.c-top-special__buttons ul li a').hover(
                function () {
                    $(this).addClass("is-active");
                },
                function () {
                    $(this).removeClass("is-active");
                }
            );
            $('.c-top-special__buttons ul li a').on("touchstart",
                function () {
                    $(this).addClass("is-active");
                }
            );
            $('.c-top-special__buttons ul li a').on("touchend",
                function () {
                    $(this).removeClass("is-active").trigger("click");
                }
            );
        }





        //フッターメニューSPスライド
        function menuSlide() {
            var win = $(window).innerWidth();
            if (win > 750) {
                return false;
            }
            $('.l-footer__block').on('click', function () {
                $(this).children(".l-footer__menutitle").toggleClass('is-open');
                $(this).children(".l-footer__menulist.is-sub").slideToggle();
            })
        }

        function scrollAnimation() {
            ScrollReveal().reveal('.c-main-visual__text', {
                easing: 'ease',
                duration: 1000,
                distance: '50px',
                opacity: 0,
                origin: 'bottom',
                mobile: false
            });
            ScrollReveal().reveal('.c-heading.is-xlg.is-border-side.u-hidden-sm', {
                easing: 'ease',
                duration: 1000,
                distance: '40px',
                opacity: 0,
                origin: 'bottom',
                mobile: false
            });
            ScrollReveal().reveal('.c-top-aboutus__text', {
                easing: 'ease',
                delay: 800,
                duration: 1000,
                distance: '80px',
                opacity: 0,
                origin: 'bottom',
                mobile: false
            });
            ScrollReveal().reveal('.c-special-hero-rightdown__title', {
                easing: 'ease',
                delay: 800,
                duration: 1000,
                distance: '80px',
                opacity: 0,
                origin: 'bottom',
                mobile: false
            });
            ScrollReveal().reveal('.c-special-hero-rightdown__text', {
                easing: 'ease',
                delay: 800,
                duration: 1000,
                distance: '80px',
                opacity: 0,
                origin: 'bottom',
                mobile: false
            });
            ScrollReveal().reveal('.c-round-link.is-01', {
                easing: 'ease',
                delay: 200,
                duration: 800,
                distance: '80px',
                opacity: 0,
                origin: 'bottom',
                mobile: false
            });
            ScrollReveal().reveal('.c-round-link.is-02', {
                easing: 'ease',
                delay: 700,
                duration: 800,
                distance: '80px',
                opacity: 0,
                origin: 'bottom',
                mobile: false
            });
            ScrollReveal().reveal('.c-round-link.is-03', {
                easing: 'ease',
                delay: 1300,
                duration: 800,
                distance: '80px',
                opacity: 0,
                origin: 'bottom',
                mobile: false
            });
            ScrollReveal().reveal('.c-special-hero-leftcenter__title', {
                easing: 'ease',
                delay: 800,
                duration: 1000,
                distance: '80px',
                opacity: 0,
                origin: 'bottom',
                mobile: false
            });
            ScrollReveal().reveal('.c-special-hero-leftcenter__text', {
                easing: 'ease',
                delay: 800,
                duration: 1000,
                distance: '80px',
                opacity: 0,
                origin: 'bottom',
                mobile: false
            });
            ScrollReveal().reveal('.c-special-hero-rightup__text', {
                easing: 'ease',
                delay: 600,
                duration: 1000,
                distance: '80px',
                opacity: 0,
                origin: 'bottom',
                mobile: false
            });
            ScrollReveal().reveal('.c-hero-block-square__inner', {
                easing: 'ease',
                delay: 600,
                duration: 1000,
                distance: '30px',
                opacity: 0,
                origin: 'bottom',
                mobile: false
            });
            ScrollReveal().reveal('.c-wideimg-block__block', {
                easing: 'ease',
                delay: 600,
                duration: 1000,
                distance: '30px',
                opacity: 0,
                origin: 'bottom',
                mobile: false
            });
            ScrollReveal().reveal('.c-hero-block-fullwide__content', {
                easing: 'ease',
                delay: 600,
                duration: 1000,
                distance: '30px',
                opacity: 0,
                origin: 'bottom',
                mobile: false
            });
            ScrollReveal().reveal('.c-history__block', {
                easing: 'ease',
                delay: 300,
                duration: 500,
                distance: '30px',
                opacity: 0,
                origin: 'top',
                mobile: false
            });
            ScrollReveal().reveal('.c-hero-block-fullwide__content', {
                easing: 'ease',
                delay: 600,
                duration: 1000,
                distance: '30px',
                opacity: 0,
                origin: 'bottom',
                mobile: false
            });

        }


        /**
         * ループスライダー
         */
        function loopSlider() {
            var targetInner = $('.c-loop-slider__inner'),
                targetInnerUl = $('.c-loop-slider__inner > ul'),
                targetInnerItems = targetInnerUl.children(),
                slideEasing = 'linear',
                slideSpeed = 9000;
            for (var i = 0; i < 2; i++) {
                targetInnerItems.clone().prependTo(targetInnerUl);
                targetInnerItems.clone().appendTo(targetInnerUl);
            }
            targetInnerUl.each(function () {
                var self = $(this);
                //liの個数を取得
                var selfChildItemLength = self.find('li').length;
                //liの幅を取得
                var selfChildList = self.find('li').innerWidth();
                //ulを複製する
                // self.clone().appendTo( targetInner );
                //ulの親divに幅を付与する
                // targetInner.width( ( selfChildList * selfChildItemLength ) * 2 )
                targetInner.width(selfChildList * selfChildItemLength);

                /*
                 *
                 * 親divをアニメーションさせる
                 *
                 * */
                function galleryAnimate() {
                    targetInner.animate(
                        {
                            left: '-' + ((selfChildList * selfChildItemLength) / 3 * 2) + 'px'
                        }, {
                            duration: slideSpeed * selfChildItemLength,
                            easing: slideEasing,
                            complete: function () {
                                targetInner.css({
                                    left: 0
                                });
                                galleryAnimate()
                            }
                        }
                    );
                }

                galleryAnimate()
            });
        }


        //ボタンの中身をspanで囲む
        function buttonwrap() {
            $(".c-button").wrapInner("<span></span>");
        }

        //owlcarousel
        function owlCarousel() {
            var owls = $('.owl-carousel');
            if (owls.length === 0) {
                return false
            }
            if( $(".js-news-line-feed.owl-carousel").length > 0 ) {
              $('.js-news-line-feed.owl-carousel').owlCarousel({
                items: 1,
                margin: 0,
                dots: false,
                loop: true,
                nav: false,
                autoplayHoverPause: true,
                autoplay: true,
                autoplayTimeout: 7000,
                autoplaySpeed: 500,
                autoWidth: false,
                autoHeight: false,
                center: false
              });
            }
            //->スライダー
            owls.imagesLoaded(function () {
                $('.c-main-visual__slider').owlCarousel({
                    items: 1,
                    margin: 0,
                    dots: false,
                    loop: true,
                    nav: false,
                    autoplayHoverPause: true,
                    autoplay: true,
                    autoplaySpeed: 1500,
                    autoWidth: false,
                    autoHeight: false,
                    center: true,
                    navText: ['<img src="/wp-content/themes/hontaka-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/hontaka-html/dist/assets/images/icon-slider-next.svg" />'],
                });
            });
            //->カルーセル
            owls.imagesLoaded(function () {
                $('.c-main-visual__carousel').owlCarousel({
                    items: 1,
                    margin: 16,
                    dots: true,
                    loop: true,
                    nav: true,
                    autoplayHoverPause: true,
                    autoplay: false,
                    autoplaySpeed: 500,
                    autoWidth: false,
                    autoHeight: false,
                    center: true,
                    navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>', '<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
                    responsive: {
                        // breakpoint from 0 up
                        0: {
                            stagePadding: 32,
                        },
                        // breakpoint from 750  up
                        750: {
                            stagePadding: 64,
                        },
                        // breakpoint from 950 up
                        950: {
                            stagePadding: 156,
                        },
                        1400: {
                            stagePadding: 312,
                        }
                    }
                });
            });
            //->カルーセル_ノーマル
            owls.imagesLoaded(function () {
                $('.c-main-visual__carousel.is-normal').owlCarousel({
                    items: 1,
                    margin: 8,
                    dots: true,
                    loop: true,
                    nav: true,
                    autoplayHoverPause: true,
                    autoplay: false,
                    autoplaySpeed: 500,
                    autoWidth: false,
                    autoHeight: false,
                    center: true,
                    navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>', '<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
                    responsive: {
                        // breakpoint from 0 up
                        0: {
                            stagePadding: 32,
                        },
                        // breakpoint from 750  up
                        750: {
                            stagePadding: 64,
                        },
                        // breakpoint from 950 up
                        950: {
                            stagePadding: 156,
                        },
                        1400: {
                            stagePadding: 312,
                        }
                    }
                });
            });
            //->カルーセル_レイヤー
            owls.imagesLoaded(function () {
                $('.c-main-visual-layer__carousel').owlCarousel({
                    items: 1,
                    margin: 0,
                    dots: true,
                    loop: true,
                    nav: false,
                    autoplayHoverPause: true,
                    autoplay: true,
                    autoplaySpeed: 500,
                    autoWidth: false,
                    autoHeight: false,
                    center: true,
                    navText: ['<img src="/wp-content/themes/hontaka-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/hontaka-html/dist/assets/images/icon-slider-next.svg" />'],
                });
            });
            //->カード_カルーセル
            owls.imagesLoaded(function () {
                $('.js-card-slider').owlCarousel({
                    margin: 0,
                    dots: true,
                    loop: true,
                    nav: true,
                    autoplayHoverPause: true,
                    autoplay: true,
                    autoplaySpeed: 500,
                    autoWidth: false,
                    autoHeight: false,
                    center: true,
                    navText: ['<img src="/wp-content/themes/hontaka-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/hontaka-html/dist/assets/images/icon-slider-next.svg" />'],
                    responsive: {
                        // breakpoint from 0 up
                        0: {
                            items: 1,
                            // stagePadding: 20,
                        },
                        560: {
                            items: 2,
                            // stagePadding: 10,
                        },
                        // breakpoint from 750 up
                        1080: {
                            items: 3,
                            dots: false,
                        }
                    }
                });
            });
        }

        $(function () {
            owlCarousel();
            menuSlide();
            buttonwrap();
            loopSlider();
            scrollAnimation();
            hoverImage();
        });
    }
}

window.GApp = new App();
